import { FppFilterSettings } from "@/features/search-filter/types/FppFilterSettings";

export const statisticsByAgreedVolumeFilterSettings: FppFilterSettings = {
  statNumberAndIndexEnabled: true,
  statNumberAndIndexHeader: "Stat number/index",
  sellerEnabled: true,
  routePairEnabled: true,
  routePairHeader: "Routes",
  salesRegionEnabled: true,
  salesRegionHeader: "Sales region",
};
